export default __webpack_public_path__ + "static/media/american_medical_association@3x.5f4802c6.png";